// import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./AccountStatus.css";
// // import "../../../src/App.css";
// import { TbCoin } from "react-icons/tb";
// import {
//   MdOutlineReplay,
//   MdOutlineSettings,
//   MdAccountBalanceWallet,
// } from "react-icons/md";
// import { GiWallet } from "react-icons/gi";
// import { useNavigate } from "react-router-dom";
// import { IoReorderThree } from "react-icons/io5";
// import { GrCurrency } from "react-icons/gr";
// import { RiPagesLine } from "react-icons/ri";
// import { FaBook, FaLock } from "react-icons/fa";
// import { IoMdSettings } from "react-icons/io";
// import { LuLogOut } from "react-icons/lu";
// import { ImProfile } from "react-icons/im";
// import LoginPopup from "../LoginPopup/LoginPopup";
// import Login from "../Login/Login";
// import SignUp from "../SignUp/SignUp";
// import DepositWithdraw from "../DepositWithdraw";

// import Helper from "../../helper";

// const AccountStatus = (props) => {
//   const [showLoginPopup, setShowLoginPopup] = useState(false);
//   const navigate = useNavigate();
//   const userInfo = Helper();
//   const [showPopup, setShowPopup] = useState(false);
//   const [showSignupPopup, setShowSignupPopup] = useState(false);
//   const [balance, setBalance] = useState(0);
//   const [exposure, setExposure] = useState(0);

//   let balanceWithExp = balance - Math.abs(exposure);



//   // Function to navigate to the given path
//   const navigateTo = (path) => {
//     navigate(path);
//   };

//   const togglePopup = () => {
//     setShowPopup(!showPopup);
//   };

//   const toggleSignUpPopup = () => {
//     setShowSignupPopup(!showSignupPopup);
//   };



//   return (
//     <>
//       <Login
//         showPopup={showPopup}
//         togglePopup={togglePopup}
//         handleClose={props.handleClose}
//       />
//       <SignUp
//         showSignupPopup={showSignupPopup}
//         toggleSignUpPopup={toggleSignUpPopup}
//         handleClose={props.handleClose}
//       />
//       <div className="main-section">
//         <div className="section-second mt-[18px]">
//           <nav className="navbar-account">
//             {/* <button type="button" className="btn btn-dark bet">
//               <TbCoin size={25} color="white" style={{ marginRight: 0 }} />
//               Bets
//             </button> */}
//             {/* <button type="button" className="btn btn-dark replay">
//             <MdOutlineReplay size={25} color="white" style={{ marginRight: 0 }} />
//           </button> */}
//             {/* <button
//               type="button"
//               className="btn btn-dark setting"
//               onClick={() => navigateTo("/settings")}
//             >
//               <MdOutlineSettings
//                 size={25}
//                 color="white"
//                 style={{ marginRight: 0 }}
//               />

//             </button> */}
//             <div className="username-container flex gap-2  ">
//               <svg className="mt-[2px]" width="14px" height="14px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="yellow"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z" fill="yellow"></path> <path d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z" fill="yellow"></path> </g></svg>
//               <span
//                 className="user-name text-[14px]"
//                 title={userInfo?.user_name || "User"}
//               >
//                 {userInfo?.user_name || "DemoUser"} -
//               </span>
//               <span className="text-[14px] "> ( {balance && Number(balanceWithExp).toFixed(2)}{" "})</span>

//             </div>

//           </nav>
//           <div className="w-full flex justify-between gap-1  ">
//             <div className=" flex flex-col font-bold pl-2 text-[14px]  border-rounded justify-center w-full text-white bg-[#17afc6]" style={{ border: "1px solid white", borderRadius: '3px', width: "129px", height: "55px" }}>
//               <span >Balance</span>
//               <span className="text-black font-normal  pl-4">{balance && Number(balanceWithExp).toFixed(2)}{" "}</span>
//             </div>
//             <div className="flex flex-col font-bold pl-2 text-[14px]  justify-center border-solid border-white w-full text-white bg-[#17afc6]" style={{ border: "1px solid white", borderRadius: '3px', width: "129px", height: "55px" }}>
//               <span>
//                 Exposure

//               </span>
//               <span className="text-black font-normal  pl-4">{exposure && Number(exposure).toFixed(2)}</span>

//             </div>
//           </div>
//           {props?.userInfo ? (
//             <nav
//               className="navbar-small flex my-2"

//             // style={{ display: "", height: "6vh", paddingTop: "2vw" }}
//             >

//               {/* <button
//                 className="button-83"
//                 role="button"
//                 onClick={() => navigateTo("/deposit")}
//               >
//                 Deposit{" "}
//                 <MdAccountBalanceWallet
//                   size={25}
//                   color="white"
//                   style={{ marginRight: 0, marginLeft: 0 }}
//                 />
//               </button>
//               <button
//                 className="withdraw"
//                 role="button"
//                 onClick={() => navigateTo("/withdraw")}
//               >
//                 Withdraw{" "}
//                 <GiWallet size={25} color="white" style={{ marginRight: 0 }} />
//               </button> */}
//               {/* <DepositWithdraw /> */}
//             </nav>
//           ) : (
//             <nav className="navbar-small">
//               <button
//                 className="pushable-login submit-btn login-trigger "
//                 onClick={() => togglePopup()}
//               >
//                 <span className="front-login">Login</span>
//               </button>
//               <button
//                 className="pushable-signup submit-btn login-trigger "
//                 onClick={() => toggleSignUpPopup()}
//                 style={{ width: "auto" }}
//               >
//                 <span
//                   className="front-signup"
//                   style={{
//                     width: "auto",
//                     paddingTop: 10,
//                     paddingBottom: 10,
//                     paddingLeft: 15,
//                     paddingRight: 15,
//                     fontSize: 20,
//                   }}
//                 >
//                   Sign Up
//                 </span>
//               </button>
//             </nav>
//           )}

//           <div className="vertical-navbar">
//             <ul>
//               <li>
//                 <button
//                   className="ac-button flex"
//                   onClick={() => navigateTo("/")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <IoReorderThree className="icon-button mr-2" /> */}
//                     <img src="\Images\home.png" className="w-4 mr-2" />
//                     <span> Home </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button flex"
//                   onClick={() => navigateTo("/openbets")}
//                 >
//                   <div className="flex items-center justify-start">
//                     <IoReorderThree className="icon-button mr-2" />
//                     <span> Open Bets </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button"
//                   onClick={() => navigateTo("/profitandloss")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <GrCurrency className="icon-button mr-2" /> */}
//                     <img src="\Images\profit-loss-report.svg" className="w-4 mr-2" />
//                     <span> Profit And Loss </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button"
//                   onClick={() => navigateTo("/accountstatement")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <RiPagesLine className="icon-button mr-2" />{" "} */}
//                     <img src="\Images\Account-Statement.svg" className="w-4 mr-2" />
//                     <span>Account Statement </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button flex"
//                   onClick={() => navigateTo("/profile")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <ImProfile className="icon-button mr-2" /> */}
//                     <img src="\Images\profile.png" className="w-4 mr-2" />
//                     <span>My Profile </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button flex"
//                   onClick={() => navigateTo("/referandearn")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <ImProfile className="icon-button mr-2" />{" "} */}
//                     <img src="\Images\referEarn.png" className="w-4 mr-2" />
//                     <span>Refer & Earn </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button flex"
//                   onClick={() => navigateTo("/rules")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <FaBook className="icon-button mr-2" /> */}
//                     <img src="\Images\rules.png" className="w-4 mr-2" />
//                     <span>Rules </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button flex"
//                   onClick={() => navigateTo("/changepassword")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <FaLock className="icon-button mr-2" />{" "} */}
//                     <img src="\Images\change-password.svg" className="w-4 mr-2" />
//                     <span>Change Password </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="ac-button flex"
//                   onClick={() => navigateTo("/settings")}
//                 >
//                   <div className="flex items-center justify-start">
//                     {/* <IoMdSettings className="icon-button mr-2" />{" "} */}
//                     <img src="\Images\gear.png" className="w-4 mr-2" />
//                     <span>Settings </span>
//                   </div>
//                 </button>
//               </li>
//               <li>
//                 {props?.userInfo && (
//                   <button
//                     type="button"
//                     className="ac-button flex"
//                     onClick={() => props?.handleLogout()}
//                   >
//                     <div className="flex items-center justify-start">
//                       <img src="\Images\log-out.svg" className="w-4 mr-2" />
//                       <span>Logout </span>
//                       {/* <LuLogOut size={25} color="white" style={{ marginLeft: 10 }} /> */}
//                     </div>
//                   </button>
//                 )}
//               </li>
//             </ul>
//           </div>
//           {showLoginPopup && (
//             <LoginPopup onClose={() => setShowLoginPopup(false)} />
//           )}

//         </div >
//       </div >
//     </>
//   );
// };

// export default AccountStatus;

"use client"
import { useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "./AccountStatus.css"
import { IoReorderThree } from "react-icons/io5"
import LoginPopup from "../LoginPopup/LoginPopup"
import Login from "../Login/Login"
import SignUp from "../SignUp/SignUp"
import Helper from "../../helper"
import { useNavigate } from "react-router-dom" // Import useNavigate
import DepositWithdraw from "../DepositWithdraw"

const AccountStatus = (props) => {
  const [showLoginPopup, setShowLoginPopup] = useState(false)
  const navigate = useNavigate() // Declare useNavigate
  const userInfo = Helper()
  const [showPopup, setShowPopup] = useState(false)
  const [showSignupPopup, setShowSignupPopup] = useState(false)
  const [balance, setBalance] = useState(0)
  const [exposure, setExposure] = useState(0)
  const balanceWithExp = balance - Math.abs(exposure)

  // Function to navigate to the given path and close sidebar
  const navigateTo = (path) => {
    navigate(path)
    // Close the sidebar after navigation
    if (props.handleClose) {
      props.handleClose()
    }
  }

  const togglePopup = () => {
    setShowPopup(!showPopup)
  }

  const toggleSignUpPopup = () => {
    setShowSignupPopup(!showSignupPopup)
  }

  return (
    <>
      <Login showPopup={showPopup} togglePopup={togglePopup} handleClose={props.handleClose} />
      <SignUp showSignupPopup={showSignupPopup} toggleSignUpPopup={toggleSignUpPopup} handleClose={props.handleClose} />
      <div className="main-section ">
        <div className="section-second mt-[18px]">
          <nav className="navbar-account">
            <div className="username-container flex gap-2">
              <svg
                className="mt-[2px]"
                width="14px"
                height="14px"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                stroke="yellow"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z"
                    fill="yellow"
                  ></path>
                  <path d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z" fill="yellow"></path>
                </g>
              </svg>
              <span className="user-name text-[14px]" title={userInfo?.user_name || "User"}>
                {userInfo?.user_name || "DemoUser"} -
              </span>
              <span className="text-[14px]">( {balance && Number(balanceWithExp).toFixed(2)} )</span>
            </div>
          </nav>

          {/* <div className="w-full flex justify-between gap-1">
            <div
              className="flex flex-col font-bold pl-2 text-[14px] border-rounded justify-center w-full text-white bg-[#17afc6]"
              style={{
                border: "1px solid white",
                borderRadius: "3px",
                width: "129px",
                height: "55px",
              }}
            >
              <span>Balance</span>
              <span className="text-black font-normal pl-4">{balance && Number(balanceWithExp).toFixed(2)}</span>
            </div>
            <div
              className="flex flex-col font-bold pl-2 text-[14px] justify-center border-solid border-white w-full text-white bg-[#17afc6]"
              style={{
                border: "1px solid white",
                borderRadius: "3px",
                width: "129px",
                height: "55px",
              }}
            >
              <span>Exposure</span>
              <span className="text-black font-normal pl-4">{exposure && Number(exposure).toFixed(2)}</span>
            </div>
          </div> */}
          <div className="w-full flex gap-1">
            {/* Balance Box */}
            <div
              className="flex flex-1 flex-col justify-center rounded-[3px] border border-white bg-[#17afc6] p-2 font-bold text-white text-[14px] h-[55px]"
            >
              <span>Balance</span>
              <span className="text-black font-normal pl-4">{balance && Number(balanceWithExp).toFixed(2)}</span>
            </div>

            {/* Exposure Box */}
            <div
              className="flex flex-1 flex-col justify-center rounded-[3px] border border-white bg-[#17afc6] p-2 font-bold text-white text-[14px] h-[55px]"
            >
              <span>Exposure</span>
              <span className="text-black font-normal pl-4">{exposure && Number(exposure).toFixed(2)}</span>
            </div>
          </div>

          <div className="">{userInfo && <DepositWithdraw />}</div>

          <div className="vertical-navbar">
            <ul>
              <li>
                <button className="ac-button flex" onClick={() => navigateTo("/")}>
                  <div className="flex items-center justify-start">
                    <img src="/Images/home.png" className="w-4 mr-2" alt="Home" />
                    <span> Home </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button flex" onClick={() => navigateTo("/openbets")}>
                  <div className="flex items-center justify-start">
                    {/* <IoReorderThree className="icon-button mr-2" /> */}
                    <img src="\Images\unsettle-bet.svg" className="icon-button mr-2 w-4" />
                    <span> Open Bets </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button" onClick={() => navigateTo("/profitandloss")}>
                  <div className="flex items-center justify-start">
                    <img src="/Images/profit-loss-report.svg" className="w-4 mr-2" alt="Profit Loss" />
                    <span> Profit And Loss </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button" onClick={() => navigateTo("/profit-loss-event-market-all")}>
                  {/* <button className="ac-button" onClick={() => navigateTo("/accountstatement")}> */}
                  <div className="flex items-center justify-start">
                    <img src="/Images/Account-Statement.svg" className="w-4 mr-2" alt="Account Statement" />
                    <span>Account Statement </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button flex" onClick={() => navigateTo("/profile")}>
                  <div className="flex items-center justify-start">
                    <img src="/Images/profile.png" className="w-4 mr-2" alt="Profile" />
                    <span>My Profile </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button flex" onClick={() => navigateTo("/referandearn")}>
                  <div className="flex items-center justify-start">
                    <img src="/Images/referEarn.png" className="w-4 mr-2" alt="Refer Earn" />
                    <span>Refer & Earn </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button flex" onClick={() => navigateTo("/rules")}>
                  <div className="flex items-center justify-start">
                    <img src="/Images/rules.png" className="w-4 mr-2" alt="Rules" />
                    <span>Rules </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button flex" onClick={() => navigateTo("/changepassword")}>
                  <div className="flex items-center justify-start">
                    <img src="/Images/change-password.svg" className="w-4 mr-2" alt="Change Password" />
                    <span>Change Password </span>
                  </div>
                </button>
              </li>
              <li>
                <button className="ac-button flex" onClick={() => navigateTo("/settings")}>
                  <div className="flex items-center justify-start">
                    <img src="/Images/gear.png" className="w-4 mr-2" alt="Settings" />
                    <span>Settings </span>
                  </div>
                </button>
              </li>
              <li>
                {props?.userInfo && (
                  <button type="button" className="ac-button flex" onClick={() => props?.handleLogout()}>
                    <div className="flex items-center justify-start">
                      <img src="/Images/log-out.svg" className="w-4 mr-2" alt="Logout" />
                      <span>Logout </span>
                    </div>
                  </button>
                )}
              </li>
            </ul>
          </div>

          {/* {showLoginPopup && <LoginPopup onClose={() => setShowLoginPopup(false)} />} */}
        </div>
      </div>
    </>
  )
}

export default AccountStatus
